import React from 'react';
import { makeStyles,CircularProgress,Backdrop } from '@material-ui/core';
import AutoComplete from "../../../SkapaMote/Inputs/AutoComplete";
import Orgnr from "../../../SkapaMote/Inputs/Orgnr";
import Divider from "@material-ui/core/Divider";
import KundAutoComplete from '../../../KundAutoComplete'
import {isUndefined,isEmpty} from 'lodash'
import Spinner from "../../../Spinner"
const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));
function KundInfo(props) {
    const classes = useStyles();
    const [isLoading,setisLoading]= React.useState(false)
    const onStartLoading=()=>{setisLoading(true)}
    const onEndLoading=()=>{setisLoading(false)}
    //console.log(props)
    return (
        <div>
            <div style={{ height: 'auto', paddingTop: '15px' }} className="row my-1">
            <div className="col-8" style={{ height: 'auto' }}>
            {parseInt(props.isFrom)===0?
                <KundAutoComplete
                // Kund=nO{rder.Kund}
                Value={isUndefined(props.Kund.KundNamn)?0:props.Kund.KundNamn}
                selectthisKund={props.selectthisKund}
                    /> 
                :
                <AutoComplete
                KundNamn={props.Kund.KundNamn}
                Kund={props.Kund}
                isFrom={props.isFrom}
                selectthisKund={props.selectthisKund}
                onStartLoading={onStartLoading}
                onEndLoading={onEndLoading}
                />}
            </div>
            {
                isLoading===true?
                <Spinner/>
                :
                <>
            <div className="col-4"  style={{ height: 'auto' }}>
                <Orgnr
                Orgnr={
                    isUndefined(props.Kund.Orgnr_Af)?"":
                    isEmpty(props.Kund.Orgnr_Af)?String(props.Kund.Orgnr).split("_")[0]:props.Kund.Orgnr_Af
                }
                />
            </div>
            </>
         }
            <div style={{ paddingTop: '15px', paddingBottom: '10px' }}>
                <Divider />
            </div>
           
            </div>
        </div>
    );
}

export default KundInfo;